import { RestError } from "../../services/rest-service/RestService";
import { useMutation, useQueryClient } from "react-query";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { keys } from "./Keys";
import { IEditDTO } from "../../services/alarm-scheme-data-service/Models";
import AlarmSchemeAdministrationDataService from "../../services/alarm-scheme-data-service/AlarmSchemeAdministrationService";
import {keys as setpointAdminKeys} from "../alarm-setpoint-admin/Keys";

export type MutationContextType = {
    previous: IEditDTO | undefined;
};

export type UseSaveAlarmSchemeParameters = {
    groupID: number,
    organizationID: number
} & BaseUseMutationParameters<IEditDTO, IEditDTO>;

export function useSaveAlarmScheme({
    groupID,
    organizationID,
    onError,
    onSuccess
}: UseSaveAlarmSchemeParameters) {
    const queryClient = useQueryClient();

    return useMutation<IEditDTO, RestError, IEditDTO, MutationContextType>(
        (scheme) => {
            return AlarmSchemeAdministrationDataService.saveAlarmScheme(
                organizationID,
                groupID,
                scheme
            );
        },
        {
            onMutate: async (item: IEditDTO) => {

                await queryClient.cancelQueries(keys.all);

                queryClient.invalidateQueries({
                    queryKey: [keys.all, setpointAdminKeys.referenceData],
                    active: true,
                    inactive: true
                    //type: 'all'
                });

                queryClient.refetchQueries({
                    queryKey: [keys.getAlarmScheme, keys.referenceData, setpointAdminKeys.referenceData],
                    active: true,
                    inactive: true
                });

                if (item.id > 0) {
                    queryClient.setQueryData<IEditDTO>(keys.getAlarmScheme(organizationID, groupID, item.id), item);
                }

                const prev = queryClient.getQueryData<IEditDTO>(keys.getAlarmScheme(organizationID, groupID, item.id));

                return {
                    previous: prev ?? item
                };
            },
            onError: onError,
            onSuccess: onSuccess,
            // onSettled: (_data, error, _configuration, context) => {

            //     // const otherKeys = _configuration.pageConfigurationType === PageConfigurationTypeEnum.SummaryListing_RTS ?
            //     // deviceSummaryKeys :
            //     // wellSummaryKeys;                

            //     // if (error && context?.previousConfigurations) {

            //     //     queryClient.setQueryData<PageConfigurationDataModel3>(
            //     //         otherKeys.configurationList(
            //     //             groupID
            //     //         ),
            //     //         context?.previousConfigurations
            //     //     );
            //     // }

            //     // // If there was an error in saving our configuration, such as name in use,
            //     // // then don't invalidate the queries, otherwise the configuration will
            //     // // reload and our changes will be discarded.
            //     // if (!error) {
            //     //     queryClient.invalidateQueries(keys.all);
            //     //     queryClient.invalidateQueries(otherKeys.all);
            //     // }
            // }
        }
    );
}
